import jwts from "erayic-com-pack/encapsulation/JWT/JWTs";
import { Enum__Fy3IrcUserApiType, I_Fy3IrcTextureItemAction } from "./bean";
import { DateAdd, timeToString } from "erayic-com-pack/utils/timerToString";
import { $Bus } from "erayic-com-pack/EventBus";
import { Enum_TextureType } from "erayic-com-pack/utils/enum";
import { I_AddTextureData } from "erayic-com-pack/EventBus/bean/mapEventsBean";

/** 处理红外卫星3号纹理图（绘制+删除+数据获取） */
export const Fy3LrcDataTextureGridImage = {
    /**
     * 绘制纹理图
     * @param option 产品类型
     * @param date 时间
     */
    async draw( option: I_Fy3IrcTextureItemAction, date: string ){
        let data = await this.getGridImage(option, date);
        if( data ) {
            let params: I_AddTextureData = {
                LayerId: option.satellite + option.el + option.ad,
                DataName: option.satellite + option.label,
                DataSet: {},
                DisplayIndex: 0,
                IsUseSingleCustomLayer: true,
                IsDrawColorBar: false,
            };
            let value = Object.values(data);
            params.DataSet[timeToString(DateAdd('h',0,date), 'yyyy-MM-dd HH:mm')] = value[value.length - 1];
            if( value[value.length - 1] == "" ) {
                $Bus.MapEvent.Texture.emit("TextureDel", {
                    LayerId: params.LayerId,
                    Type: [Enum_TextureType.Grid, Enum_TextureType.GridVector],
                    IsSaveTriggerState: true,
                });
            } else {
                $Bus.MapEvent.Texture.emit("AddTexture", params);
            }
        } else {
            $Bus.MapEvent.Texture.emit("TextureDel", {
                LayerId: option.satellite + option.el + option.ad,
                Type: [Enum_TextureType.Grid, Enum_TextureType.GridVector],
                IsSaveTriggerState: true,
            });
        }
    },
    /** 删除 */
    delete( option: I_Fy3IrcTextureItemAction ) {
        $Bus.MapEvent.Texture.emit("TextureDel", {
            LayerId: option.satellite + option.el + option.ad,
            Type: [Enum_TextureType.Grid, Enum_TextureType.GridVector],
            IsSaveTriggerState: false,
        });
    },
    /**
     * 获取纹理图产品
     * @param option 产品类型
     * @param date 时间
     */
    async getGridImage( option: I_Fy3IrcTextureItemAction, date: string )  {
        let res: { success: boolean; data: null | string; } = { success: false, data: null };
        if( option.UserApiType == Enum__Fy3IrcUserApiType.查询极轨卫星产品 ) {
            res = <{ success: boolean, data: null | string }>await (await jwts.getInstance()).GetHttp(option.UserApiType, {
                satellite: option.satellite,
                eles: option.el,
                date: timeToString(DateAdd('h',0,date), 'yyyy-MM-dd'),
                ad: option.ad,
            });
        } else if( option.UserApiType == Enum__Fy3IrcUserApiType.查询静止卫星产品 ) {
            res = <{ success: boolean, data: null | string }>await (await jwts.getInstance()).GetHttp(option.UserApiType, {
                satellite: option.satellite,
                eles: option.el,
                dateTime: timeToString(DateAdd('h',0,date), 'yyyy-MM-dd HH:mm:00'),
            });
        }
        
        return res.data;
    }
}